import React from 'react'
import Layout from '../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const WALLIS = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        '/img/instruments/wallis.png',
        '/img/instruments/wallis.png'
    ];


    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/RD-Instruments/Particle-Size-and-Zeta-with-Molecular-Weight">Particle-Size-and-Zeta-with-Molecular-Weight</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>WALLIS</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>WALLIS </h3>
                                <div className='descriptionHead' style={{ textAlign: 'justify' }}>

                                    <ul style={{ paddingLeft: "20px" }}>
                                        <li>High Resolution Zeta Potential measurement </li>
                                        <li>Broad Measurement rangefrom-200 mV to +200 mV </li>
                                        <li>Result with no Electro-osmosis Interference </li>
                                        <li>Measurement principle: Laser Doppler Electrophoresis (LDE)
                                            Scattering angle: Single angle for zeta potential at 17°, Particle size range: 1 nm up to 100 µm Molecular weight range: NA, Software: ZetaQTM, Key measurements: Zeta Potential.
                                        </li>
                                    </ul>

                                    <a
                                        href="https://cordouan-tech.com" target='_blank'
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </div>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default WALLIS